function ExpireMessageContainer() {
  return (
    <div className='mx-auto w-full max-w-5xl text-sm font-medium text-red-600'>
      <p>* توجه داشته باشید:</p>
      <ol className='ms-4'>
        <li>1. تعداد شرکت‌کنندگان در حین زمان برگزاری آزمون، به‌روز‌رسانی می‌شود.</li>
        <li>2. رتبه و تراز پس از اتمام مهلت شرکت در آزمون محاسبه خواهد شد.</li>
      </ol>
    </div>
  );
}

export default ExpireMessageContainer;
